import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { Observable, of, take } from "rxjs";
import { environment } from "../../../environments/environment";
import {
  RegistrationData,
  RegistrationState,
} from "../../features/registration/registration.models";
import { registrationActions } from "../../features/registration/store/actions";
import { selectRegistrationState } from "../../features/registration/store/selectors";
import { RegisterApiResponse } from "../../shared/models/api.response";
import { RegisterDTO } from "../../shared/models/dto.models";
import { getIdentificationDetail } from "../../shared/utils/helper_functions";

@Injectable({
  providedIn: "root",
})
export class RegisterService {
  constructor(
    private http: HttpClient,
    private store: Store<{ registration: RegistrationState }>
  ) {}

  registerUser() {
    this.store
      .select(selectRegistrationState)
      .pipe(take(1))
      .subscribe({
        next: (state) => {
          if (state?.data) {
            this.store.dispatch(
              registrationActions.requestRegistration(state.data)
            );
          }
        },
      });
  }

  register(registerData: RegistrationData): Observable<RegisterApiResponse> {
    //return of({ cardNumber: "6312175691309819" } as RegisterApiResponse); //Test

    let registerDTO: RegisterDTO = {
      identificationDocument: getIdentificationDetail(
        registerData.identificationDocument
      ),
      termsAccepted: registerData.termsAccepted,
      marketingConsent: registerData.marketingConsent,
      personalInfo: registerData.personalInfo,
      mobile: registerData.mobile,
      canvasser: registerData.canvasser,
    };

    if (registerData.email && registerData.email?.address !== "") {
      registerDTO.email = registerData.email;
    }

    return this.http.post<RegisterApiResponse>(
      `${environment.apiUri}/profile/register`,
      registerDTO
    );
  }
}
